<template>
  <div>
    <section class="startegy">
      <Header></Header>
      <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
    <label class="verticalLabel right reportTitle">technology</label> -->
      <div class="startegy_main_content">
        <div class="slide-section">
          <div class="upperText">
            <!-- <div class="startegy-title">
              <h4>TECHNOLOGY</h4>
            </div> -->
          </div>
          <div class="main-slides">
            <VueSlickCarousel
              v-bind="sliderSettingsmain"
              @init="onInitCarousel"
              @afterChange="onAfterChange"
              @beforeChange="onBeforeChange"
              ref="carousel"
            >
              <div class="slide slide-1" id="1" data-theme="dark">
                <div class="slide__image">
                  <img v-if="$i18n.locale=='en'" src="@/assets/images/banners/technology1.png" alt="" />
                  <img class="ar-banner" src="@/assets/images/banners/technology1-ar.png" alt="" />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title" v-html="techonology.slide_one.title">
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section" @click="this.scrollTop">
                        <div class="scroll-text">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slide slide-2" id="2" data-theme="light">
                <div class="slide__image">
                  <img src="@/assets/images/banners/technology3.png" alt="" />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title">
                        {{techonology.slide_two.title}}
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section" @click="this.scrollTop">
                        <div class="scroll-text" @click="this.scrollTop">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
            <div class="slider__nav">
              <button @click.prevent="slidePrev" class="slider__nav--previous" :class="{disabled:isFirst}">
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 87.5 66"
                >
                  <use xlink:href="#custom_left_arrow"></use>
                </svg>
              </button>
              <button @click.prevent="slideNext" class="slider__nav--next" :class="{disabled:isLast}">
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 87.5 66"
                >
                  <use xlink:href="#custom_right_arrow"></use>
                </svg>
              </button>
            </div>
          </div>
          <div class="section_footer">
            <div class="innerFooter">
              <div class="innerlink" v-if="!isFirst">
                <a href="#" @click.prevent="slidePrev">{{$t("labels.previous")}}</a>
              </div>
              <div class="innerlink" v-if="!isLast">
                <a href="#" @click.prevent="slideNext">{{$t("labels.next")}}</a>
              </div>
              <div class="innerlink scroll_top">
                <a href="#" @click="this.scrollFullTop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43">
                        <use xlink:href="#circle-arrow-down"></use> 
                    </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll_section_content">
          <div class="scrollSection _4SIGHT_content" data-slide="1">
            <div class="title-slide-content">
              <div class="slide_title">
                <h3>{{techonology.slide_one.content.title}}</h3>
              </div>
            </div>
            <div class="row main_text_content">
              <div class="col-md-12 mx-auto" v-for="(content,index) in techonology.slide_one.content.labels" :key="index+'1120'">
                <span class="unde-title">{{content.small_title}}</span>
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(para,index) in content.desc" :key="index+'640'">{{para}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scrollSection creating_digital_future" data-slide="2">
            <div class="title-slide-content">
              <div class="slide_title">
                <h3>{{techonology.slide_two.content.title}}</h3>
              </div>
            </div>
            <div class="row main_text_content">
              <div class="col-md-12 mx-auto">
                <span class="unde-title"
                  >{{techonology.slide_two.content.label_one}}</span
                >
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-html="techonology.slide_two.content.para_one"></p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mx-auto">
                <span class="unde-title text-capitalize">{{techonology.slide_two.content.label_two}}</span>
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(text,index) in techonology.slide_two.content.para_two" :key="index+'564016'">{{text}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mx-auto">
                <span class="unde-title"
                  >{{techonology.slide_two.content.label_three}}</span
                >
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(text,index) in techonology.slide_two.content.para_three" :key="index+'5640sd16'">{{text}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mx-auto">
                <div class="">
                  <div class="section_main-content">
                    <div class="row chart_Section align-items-center">
                      <div class="col-lg-6">
                        <!-- <div class="main_tite text-center">
                          % UNSATISFIED CUSTOMERS
                        </div> -->
                        <div class="image image-graph">
                          <img class="img-fluid" :src="require(`@/assets/images/${techonology.slide_two.content.image_three}`)" alt="">
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="main_content">
                          <p v-html="techonology.slide_two.content.para_three_remaning"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mx-auto">
                <span class="unde-title">{{techonology.slide_two.content.label_four}}</span>
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(text,i) in techonology.slide_two.content.para_four" :key="i+'540984'">{{text}}</p>
                  </div>
                </div>
                <span class="unde-title">{{techonology.slide_two.content.label_five}}</span>
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(text,i) in techonology.slide_two.content.para_five" :key="i+'4525552'">{{text}}</p>
                  </div>
                </div>
                <span class="unde-title">{{techonology.slide_two.content.label_six}}</span>
                <div class="margin-bottom">
                  <div class="section_main-content">
                    <p v-for="(text,i) in techonology.slide_two.content.para_six" :key="i+'45255552'">{{text}}</p>
                  </div>
                </div>
                <div class="chartWrapper">
                    
                    <div id="chart" class="chart">
                      <p class="chartHeading">{{techonology.slide_two.content.chart_one}}</p>
                    <VueApexCharts
                      ref="chart"
                      type="bar"
                      :options="chartOptions"
                      :series="series"
                    ></VueApexCharts>
                </div>
                <div id="chart2" class="chart">
                  <p class="chartHeading">{{techonology.slide_two.content.chart_two}}</p>
                    <VueApexCharts
                      ref="chart"
                      type="bar"
                      :options="Options"
                      :series="Chatseries"
                    ></VueApexCharts>
                </div>
                </div>
                <div class="digitization">
                    <ul>
                        <li>
                            <div class="image custom_image">
                                <img :src="require(`@/assets/images/svg/${techonology.slide_two.content.lastSection_image[0].image}`)" alt="">
                            </div>
                            <h4 v-html="techonology.slide_two.content.lastSection_image[0].title"></h4>
                            <span v-html="techonology.slide_two.content.lastSection_image[0].label"></span>
                        </li>
                        <li>
                            <div class="image custom_image">
                                <img :src="require(`@/assets/images/svg/${techonology.slide_two.content.lastSection_image[1].image}`)" alt="">
                            </div>
                            <h4 v-html="techonology.slide_two.content.lastSection_image[1].title"></h4>
                            <span v-html="techonology.slide_two.content.lastSection_image[1].label"></span>
                        </li>
                        <li>
                            <div class="image custom_image meter_image">
                                <img :src="require(`@/assets/images/svg/${techonology.slide_two.content.lastSection_image[2].image}`)" alt="">
                            </div>
                            <h4 v-html="techonology.slide_two.content.lastSection_image[2].title"></h4>
                            <span v-html="techonology.slide_two.content.lastSection_image[2].label"></span>
                        </li>
                        <li>
                            <div class="image custom_image">
                                <img :src="require(`@/assets/images/svg/${techonology.slide_two.content.lastSection_image[3].image}`)" alt="">
                            </div>
                            <h4 v-html="techonology.slide_two.content.lastSection_image[3].title"></h4>
                            <span v-html="techonology.slide_two.content.lastSection_image[3].label"></span>
                        </li>
                        <li>
                            <div class="image custom_image">
                                <img :src="require(`@/assets/images/svg/${techonology.slide_two.content.lastSection_image[4].image}`)" alt="">
                            </div>
                            <h4 v-html="techonology.slide_two.content.lastSection_image[4].title"></h4>
                            <span v-html="techonology.slide_two.content.lastSection_image[4].label"></span>
                        </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "@/assets/sccs/strategy.scss";
import VueSlickCarousel from "vue-slick-carousel";
import VueApexCharts from "vue-apexcharts";
import strategy from '@/mixin/strategy.js';
import util from '@/mixin/util.js';
import gsap from "gsap";
import data from "@/components/Techonology/techonology";
export default {
  name: "strategy",
  mixins: [strategy, util],
  components: {
    VueSlickCarousel,
    VueApexCharts,
  },
  data() {
    return {
        totalSlides: 2,
        isFirst: true,
        isLast: false,
        techonology:data,
          series: [{
            name: this.$i18n.locale=="en" ? 'year' : 'سنة',
            data: [6, 8, 10, 12, 14, 13,  15, 12, 11 , 12 , 12, 12]
          }],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
              
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '30%',
                endingShape: 'rounded'
              },
              
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              // categories: data.slide_two.content.categories,
            },
            yaxis: {
              title: {
                text: this.$i18n.locale=="en" ? 'Million' : 'مليون',
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val 
                }
              }
            }
          },
          Chatseries: [{
            name: this.$i18n.locale=="en" ? 'year' : 'سنة',
            data: [300000 , 600000, 500000, 400000, 800000, 1000000, 950000 , 900000]
          }],
          Options: {
            chart: {
              type: 'bar',
              height: 350,
              
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '30%',
                endingShape: 'rounded'
              },
              
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              // categories: data.slide_two.content.categories_two,
            },
            // yaxis: {
            //   title: {
            //     text: 'Million'
            //   }
            // },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val 
                }
              }
            }
          },
      sliderSettingsmain: {
        slidesToShow: 1,
        slideToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        cssEase: "ease-in",
        speed: 1000,
        draggable: false,
        swipe:false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              draggable: true,
              swipe:true,
            }
          },
        ]
      },
    };
  },
  created(){
      if(this.$i18n.locale=="en"){
            this.techonology = data.en;
            this.chartOptions.xaxis.categories = data.en.slide_two.content.categories;
            this.Options.xaxis.categories = data.en.slide_two.content.categories_two;
        }
        else{
            this.techonology = data.ar;
            this.chartOptions.xaxis.categories = data.ar.slide_two.content.categories;
            this.Options.xaxis.categories = data.ar.slide_two.content.categories_two;
        }
    },
  methods: {
    
    onInitCarousel() {
        this.sliderInit();
    },
    onAfterChange(currentSlide, slick) {
      currentSlide>0 ? this.isFirst=false : this.isFirst=true;
      currentSlide < this.totalSlides -1 ? this.isLast=false : this.isLast=true;
    },
    onBeforeChange(slick, currentSlide, nextSlide) {
    //   console.log(currentSlide);
        this.changeTheme();
        let ns = currentSlide;
        ns >0 ? this.isFirst=false : this.isFirst=true;
        ns < this.totalSlides -1 ? this.isLast=false : this.isLast=true;
    },
    slidePrev() {
      this.$refs.carousel.prev();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    slideNext() {
      this.$refs.carousel.next();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    chart: function() {
      this.$refs.chart.init();
    },
    Chart: function(){
        let tl = gsap.timeline();
        tl.from("#chart", {
            opacity: 1,
            scrollTrigger: {
            trigger: "#chart",
            start: "top 90%",
            end: "top 55%",
            markers: false,
            scrub: 1,
            once: true,
            onEnter: ({ progress, direction, isActive }) => this.chart(),
            },
        });
            
    }
  },
  mounted() {
    this.Contents();

  },
};
</script>
<style lang="scss">
[data-page="technology"]{
  // .verticalLabel{
  //   color:#000;
  // }
}
</style>
<style lang="scss" scoped>
/deep/ {
  .text{
    position: absolute;
    color: #fff !important;
    font-size: 35px !important;
    
  }
  .apexcharts-bar-area{
        opacity:1 !important;
        fill:#aeb0b3  !important;
    }
  .apexcharts-legend.apexcharts-align-center.position-left {
    left: 50px !important;
  }
}
.light-Slide {
  .upperText {
    .startegy-title {
      h4 {
        color: black !important;
      }
      &::before {
        background: black !important;
      }
      &::after {
        background: black !important;
      }
    }
  }
  .Slide-container {
    div {
      color: #000 !important;
      &::before {
        background: black;
      }
    }
  }
  .scroll_svg_section {
    svg {
      g {
        stroke: black;
      }
    }
  }
  .slider {
    &__nav {
      button {
        color: #000;
        &:hover {
          background: unset;
          color: black;
        }
      }
    }
  }
  .scroll-svg {
    color: #000;
  }
}

/deep/ {
  @media screen and (max-width: 767px) {
    body {
      font-size: 60%;
    }
  }
  .chartWrapper{
    .apexcharts-text {
      tspan{
        @media screen and (max-width:767px){
          font-size:10px !important;
        }
      }
    }
    .chart{
      .chartHeading{
        color:#50b848 !important;
        text-align:center;
        margin-bottom:rem(30px);
        font-size:rem(17px) !important;
      }
      &:not(:last-child){
        margin-bottom:rem(40px);
      }
    }
  }
   .slider {
    &__nav {
      bottom: 50%;
      transform: translateY(50%);
      width: 100%;
      button {
        position: absolute;
        width: 80px;
        height: 80px;
        background: none;
        border: none;
        border-radius: unset;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        color: #fff;
        svg {
          width: 100% !important;
          @media screen and (max-width:991px){
            width:80% !important;
          }
        }
        &:hover {
          background: unset;
          color: #fff;
        }
      }
      &--previous {
        left: 35px;
      }
      &--next {
        right: 35px;
      }
      svg {
        transform: unset;
        margin: unset;
      }
      @media screen and (max-width: 1199px) {
        &--previous {
          left: 30px;
        }
        &--next {
          right: 30px;
        }
      }
      @media screen and (max-width:991px){
          bottom: 50%;
           &--next {
            right: 0px;
            top: 60px;
          }
          &--previous{
            right:0;
            left:auto;
          }
      }
    }
  }
  .slide.slide-1 .main-title {
    font-size: rem(90px);
    @media (max-width: 1600px) {
      font-size: rem(80px);
    }
    @media (max-width: 767px) {
      font-size: rem(60px);
    }
    @media (max-width: 575px) {
      font-size: rem(35px);
    }
  }
  .scroll_section_content {
    div[data-slide="1"] {
      .margin-bottom {
        margin-top: rem(30px) !important ;
      }
      .title-slide-content {
        .slide_title {
          h3 {
            font-size: rem(80px) !important;
            @media (max-width: 1600px) {
              font-size: rem(65px) !important;
            }
            @media (max-width: 991px) {
              font-size: rem(40px) !important;
            }
            @media (max-width: 575px) {
              font-size: rem(28px) !important;
            }
          }
        }
      }
    }
    div[data-slide="2"] {
      .margin-bottom {
        margin-top: rem(16px) !important ;
        @media screen and (max-width: 991px) {
          margin-top: rem(20px) !important ;
        }
      }
      .title-slide-content {
        .slide_title {
          h3 {
            font-size: rem(80px) !important;
            @media screen and (max-width: 1600px) {
              font-size: rem(70px) !important;
            }
            @media screen and (max-width: 991px) {
              font-size: rem(50px) !important;
              margin-bottom: rem(30px);
            }
            @media screen and (max-width: 575px) {
              font-size: rem(30px) !important;
            }
          }
        }
      }
      .main_text_content {
        p {
          font-size: 1.25rem;
          color: #7a7a7a;
        }
        span {
          display: inline-block;
					margin-top: 20px;
          font-size: 1.375rem;
          color: #bd84cb;
          font-weight: bold;
        }
      }
    }
  }
}
.digitization{
  background:#9152a1;
  padding:rem(30px) 0;
  ul{
    display:flex;
    flex-wrap:wrap;
    align-items:start;
    justify-content:center;
    li:nth-child(2){
      @media screen and (max-width:767px){
        img{
          max-width:150px !important;
        }
      }
    }
    li:nth-child(3){
      @media screen and (max-width:767px){
        img{
          max-width:150px !important;
        }
      }
    }
    li{
      font-size:rem(18px);
      color:#fff;
      @include flex(center , center);
      flex-direction:column;
      max-width:50%;
      flex:0 0 50%;
      min-height:200px;
      margin-bottom:rem(30px);
      @media screen and (max-width:575px){
        max-width:100%;
        flex:0 0 100%;
        padding:0 15px;
      }
      h4{
            font-size: rem(35px);
            font-weight: 800;
            text-align: center;
            line-height: 1;
            margin: unset;
      }
      span{
        font-size: 12px !important;
        color: #fff !important;
        text-align: center;
      }
      .image.custom_image{
          max-width: 150px;
          margin-bottom: 10px;
      }
      @media screen and (max-width:767px){
        img:nth-child(2){
          max-width:150px !important;
        }
      }
      .meter_image{
            position: relative;
            top: 60px;
      }
      .list_custom{
          position: relative;
          top:-50px;
      }
      img{
        width:150px;
      }
      span{
        font-size:rem(35px);
        font-weight:900;
        margin:rem(10px) 0;
      }
      @media screen and (max-width:991px){
        img{
          max-width:120px;
        }
      }
      @media screen and (max-width:767px){
       
        img{
          max-width:90px;
        }
      }
      @media screen and (max-width:575px){
       
        img{
          max-width:120px;
        }
      }
    }
  }
}
@media screen and (max-width:767px){
  .startegy {
    .slide-section {
      .slide__image img{
        object-position: right bottom;
      }
    }
  }
}
button.disabled {
    pointer-events: none;
    opacity: 0.3;
}

[lang="ar"]{
  /deep/ {
    .apexcharts-legend.apexcharts-align-center.position-left {
      right: 50px !important;
      left:auto !important;
    }
  }
  .chartWrapper{
      direction: ltr ;
    }
.light-Slide {
  .upperText {
    .startegy-title {
      h4 {
        color: black !important;
      }
      &::before {
        background: black !important;
      }
      &::after {
        background: black !important;
      }
    }
  }
  .Slide-container {
    div {
      color: #000 !important;
      &::before {
        background: black;
      }
    }
  }
  .scroll_svg_section {
    svg {
      g {
        stroke: black;
      }
    }
  }
  .slider {
    &__nav {
      button {
        color: #000;
        &:hover {
          background: unset;
          color: black;
        }
      }
    }
  }
  .scroll-svg {
    color: #000;
  }
}

.startegy{
  /deep/ {
   .slider {
      &__nav {
        svg {
            transform: rotate(180deg);
        }
        &--previous {
            right: 35px;
            left: auto;
        }
        &--next {
            left: 35px;
            right: auto;
        }
        @media screen and (max-width:991px){
            bottom: 50%;
            &--next {
              left: 0px;
              right:auto;
              top: 60px;
            }
            &--previous{
              left:0;
              right:auto;
            }
        }
      }
  }

}
}
}
// arsal changes
</style>
